import { normalizeTransitionOut } from '@/lib/videoTransitions';
import { transitionPreviewLayerStyles } from '@/lib/videoTransitionPreview';

/** Crossfade preview in the handoff window before the next clip starts. */
export function computeTransitionPreviewBlend(allClips, t) {
  const time = Number(t) || 0;
  const clips = allClips || [];
  for (let i = 0; i < clips.length - 1; i += 1) {
    const outgoing = clips[i];
    const incoming = clips[i + 1];
    if (normalizeTransitionOut(outgoing.transitionOut) === 'cut') continue;
    const dur = Math.max(0.1, Math.min(2, Number(outgoing.transitionDuration) || 0.5));
    const handoff = Number(incoming.startTime) || 0;
    const t0 = handoff - dur;
    if (time >= t0 && time < handoff) {
      const progress = Math.max(0, Math.min(1, (time - t0) / dur));
      const layerStyles = transitionPreviewLayerStyles(outgoing.transitionOut, progress);
      return {
        outgoing,
        incoming,
        progress,
        dur,
        handoff,
        t0,
        layerStyles,
      };
    }
  }
  return null;
}
